const React = require('react');
const WrapperWithLoading = require('./index');


module.exports = React.forwardRef((props, ref) => {
  return (
    <WrapperWithLoading
      {...props}
      ref={ref}
      className={`c0>.CircularProgress ` + (props.className || '')}
    />
  );
});
